import { pick } from './i18n.js';

const zh = {
  useEditor: '使用代码编辑器',
  templateOnly: '这里只调整模板。完整工程与调试请使用原生编辑器。',
  loading: '正在加载代码编辑器…',
  notRun: '草稿未运行；创建参数节点后可显式运行。',
  loadFailed: '编辑器加载失败，可继续使用文本框。',
};
const en: typeof zh = {
  useEditor: 'Use code editor',
  templateOnly: 'Edit templates here. Use the native editor for full projects and debugging.',
  loading: 'Loading code editor…',
  notRun: 'The draft has not run. Create a parameter node to run it.',
  loadFailed: 'The editor could not load. You can keep using the text box.',
};
export const sourceEditorToggleTextByLocale = { zh, en };
export const sourceEditorToggleText = pick<typeof zh>(sourceEditorToggleTextByLocale);
